import { useStaticQuery, graphql } from "gatsby";

export const GetURL = (url) => {

  const data = useStaticQuery(graphql`
    query {
	  allStrapiAllMenus {
	    edges {
	      node {
	        Alias
	        Label
	        URL
	        Main_Parent {
	          Alias
	          Label
	          URL
	        }
	        Sub_Parent {
	          Alias
	          Label
	          URL
	        }
	      }
	    }
	  }
    }
  `);
  
  if (url) {
    return url;
  }
}

export const isSold = (status='') => {
	console.log('test =>  status ', status)
	const soldSTatus = ['sold', 'sold sstc', 'let', 'let agreed'];
	return soldSTatus.includes(status.toLowerCase());
}